import axios, { AxiosError, AxiosResponse } from 'axios'

interface MyResponse<T> {
  data: {
    data: T
    status: string
  }
  status: number
  statusText: string
}

const isSuccessfulResponse = <T>(response: MyResponse<T>): boolean =>
  response && response.status === 200

export const manageResponse = <T>(response: MyResponse<T>) => {
  if (isSuccessfulResponse(response)) {
    return response?.data?.data ? response?.data?.data : response.data
  }
  throw new Error("Couldn't retrieve data")
}

const logError = (...args: unknown[]): void => {
  console.error(...args)
}

const manageErrorResponse = (response: AxiosResponse): void => {
  if (response.status === 404) {
    logError('Recurso não encontrado')
  } else if (response.status === 500) {
    logError('Erro interno do servidor')
  } else {
    logError('Erro desconhecido na resposta do servidor')
  }
}

const manageRequestError = (request: AxiosError): void => {
  logError('Erro na solicitação:', request)
}

const manageGeneralError = (error: unknown): void => {
  logError('Erro geral:', error)
}

export const manageError = (error: unknown): void => {
  if (axios.isAxiosError(error)) {
    const axiosError = error as AxiosError
    if (axiosError.response) {
      manageErrorResponse(axiosError.response)
    } else if (axiosError.request) {
      manageRequestError(axiosError.request)
    } else {
      manageGeneralError(error)
    }
  } else {
    manageGeneralError(error)
  }
  throw error
}
